import React from 'react'

interface FormErrorTextProps {
  message?: string
}

const FormErrorText: React.FC<FormErrorTextProps> = ({ message }) => {
  if (!message) return null

  return <p className='text-text-xs-regular text-red-500 mt-1 mb-1'>{message}</p>
}

export default FormErrorText
